import React, { ReactElement } from 'react'
import verificationStore from '../../../stores/verificaton.store'
import FundSourceEvidence from '../../../components/verification-steps/steps/questionnaire/FundSourceEvidence'

const UserFundOfEvidence: React.FC = (): ReactElement => {
  return <FundSourceEvidence verificationStore={verificationStore} />
}

export default UserFundOfEvidence
